import React, { useEffect, useMemo, useState } from "react";
import { Modal, Select, message } from "antd";
import { useTranslation } from "react-i18next";

const DocProductModal = ({
  visible,
  onClose,
  onSubmit,
  productList = [], 
}) => {
  const { t } = useTranslation();

  const [selectedProductCode, setSelectedProductCode] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);

  const selectedProduct = useMemo(() => {
    return productList.find((p) => p.code === selectedProductCode) || null;
  }, [productList, selectedProductCode]);

  const versions = selectedProduct?.versionList || [];

  // Modal açılınca alanları resetle
  useEffect(() => {
    if (visible) {
      setSelectedProductCode(null);
      setSelectedVersion(null);
    }
  }, [visible]);

  // Ürün değişince versiyon sıfırla
  useEffect(() => {
    setSelectedVersion(null);
  }, [selectedProductCode]);

  const handleOk = () => {
    if (!selectedProductCode) {
      message.error(t("Lütfen ürün seçin."));
      return;
    }
    if (!selectedVersion) {
      message.error(t("Lütfen versiyon seçin."));
      return;
    }
    if (!versions.includes(selectedVersion)) {
      message.error(t("Versiyon bulunamadı."));
      return;
    }

    onSubmit?.({
      product: selectedProduct.code,
      productName: selectedProduct.name,
      version: selectedVersion,
      versionList: versions,
    });

    onClose?.();
  };

  return (
    <Modal
      open={visible}
      title={t("Versiyon ve Ürün Seçimi")}
      onCancel={onClose}
      onOk={handleOk}
      okText={t("Kaydet")}
      cancelText={t("İptal")}
      okButtonProps={{
        style: {
          backgroundColor: "#1890ff",
          borderColor: "#1890ff",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          color: "#ff4d4f",
          borderColor: "#ff4d4f",
        },
      }}
      destroyOnClose={false}
      maskClosable={false}
    >
      <div className="flex flex-col gap-4"> 
        <div>
          <label className="text-sm text-gray-700">{t("Ürün seçin")}</label>
          <Select
            value={selectedProductCode}
            onChange={setSelectedProductCode}
            className="w-full"
            showSearch
            placeholder={t("Ürün seçin")}
            optionFilterProp="label"
            options={productList.map((p) => ({
              value: p.code,
              label: p.name,
            }))}
          />
        </div>

        <div>
          <label className="text-sm text-gray-700">{t("Ürün Versiyon seçin")}</label>
          <Select
            value={selectedVersion}
            onChange={setSelectedVersion}
            className="w-full"
            showSearch
            placeholder={selectedProductCode ? t("Versiyon seçin") : t("Önce ürün seçin")}
            disabled={!selectedProductCode}
            optionFilterProp="label"
            options={versions.map((v) => ({ value: v, label: v }))}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DocProductModal;
